"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
function projectToFormer() {
    return operators_1.map(function (_a) {
        var v1 = _a[0], _ = _a[1];
        return v1;
    });
}
exports.projectToFormer = projectToFormer;
function projectToLatter() {
    return operators_1.map(function (_a) {
        var _ = _a[0], v2 = _a[1];
        return v2;
    });
}
exports.projectToLatter = projectToLatter;
function projectTo(coordinateIndex) {
    return operators_1.map(function (list) { return list[coordinateIndex]; });
}
exports.projectTo = projectTo;
